import { atom } from 'jotai';

import type { SearchItem } from '../types/GuideMessaging';

export const showGuideMessagingModalAtom = atom<boolean>(false);
export const guideMessagingSearchItemAtom = atom<SearchItem | undefined>(
    undefined,
);
